const STAKEHOLDER_TABLE_LINES = [
  '| Name | Title / Role | Business Unit | Interview Priority |',
  '| --- | --- | --- | --- |',
  '|  | Chief Medical Officer | Clinical Operations |  |',
  '|  | VP, Data & Analytics | Enterprise IT |  |',
  '|  | Director, Compliance | Risk & Audit |  |',
  '|  | Head of Innovation | Strategy |  |',
] as const;

/** Default GFM table for stakeholder interview prep (single table, header + seed rows). */
export const DEFAULT_STAKEHOLDER_TABLE_MARKDOWN = STAKEHOLDER_TABLE_LINES.join('\n');

/** Strips the leading/trailing pipe characters from a GFM table line and returns the trimmed cell values. */
function splitTableLine(line: string): string[] {
  const inner = line.replace(/^\|/, '').replace(/\|$/, '');
  return inner.split('|').map((c) => c.trim());
}

/** Returns `true` when every cell matches the GFM separator pattern (`---`, `:---`, etc.). */
function isSeparatorRow(cells: string[]): boolean {
  if (cells.length === 0) {
    return false;
  }
  return cells.every((c) => /^:?-{3,}:?$/.test(c));
}

/** Extracts all rows from the first GFM pipe table found in the markdown string. */
function extractPipeTableRows(markdown: string): string[][] {
  const lines = markdown.split(/\r?\n/);
  const rows: string[][] = [];
  for (const raw of lines) {
    const line = raw.trim();
    if (!line.startsWith('|')) {
      if (rows.length > 0) {
        break;
      }
      continue;
    }
    rows.push(splitTableLine(line));
  }
  return rows;
}

/** Counts body rows in the first GFM pipe table where the Name column (first cell) is non-empty. */
export function countStakeholdersInTableMarkdown(markdown: string): number {
  const rows = extractPipeTableRows(markdown);
  if (rows.length < 2) {
    return 0;
  }
  const sep = rows[1];
  if (!isSeparatorRow(sep)) {
    return 0;
  }
  const dataRows = rows.slice(2);
  return dataRows.filter((cells) => (cells[0] ?? '').trim().length > 0).length;
}
